module.exports = __webpack_public_path__ + "static/media/slideimage-4.90f3c5e7.jpg";